class Shipment {
  constructor(el) {
    this.$form = $(el);
    this.$voucher = this.$form.find('.js-voucher');
    this.$carrier = this.$form.find('[name=carrier_id]');

    this.$voucher.on('change', () => this.update());

    this.$form.on('click', '.js-carrier a', (event) => {
      let $target = $(event.target);

      this.$carrier.val($target.data('id'));

      this.update().done(() => {
        this.$form.find('.active').removeClass('active');
        $target.closest('li').addClass('active');
      });

      event.preventDefault();
    });
  }

  update() {
    return $.ajax({
      url: this.$form.attr('action'),
      method: 'PUT',
      data: this.$form.serializeArray(),
      beforeSend: () => {
        this.$form.find('.fa')
          .removeClass('fa-truck')
          .addClass('fa-spin fa-circle-o-notch');
      },
      complete: () => {
        this.$form.find('.fa')
          .removeClass('fa-spin fa-circle-o-notch')
          .addClass('fa-truck');
      },
      success: () => {
        this.$form.find('.form-group')
          .addClass('has-success');

        this.$form.find('.btn')
          .removeClass('btn-default')
          .addClass('btn-success');
      }
    });
  }
}

export function init($shipments) {
  $shipments.each((index, shipment) => {
    new Shipment(shipment);
  });
}
